import { combineReducers } from '@reduxjs/toolkit';
import userReducer from '../store/slices/user';
import dealDropdownOptions from '../store/slices/dealDropdownOptions';
import dealUploadedDocuments from '../store/slices/dealUploadedDocuments';
import filtersReducer from '../store/slices/filters';

const rootReducer = combineReducers({
  user: userReducer,
  dealDropdownOptions: dealDropdownOptions,
  dealUploadedDocuments: dealUploadedDocuments,
  filters: filtersReducer
});

export default rootReducer;